import React, { useState, useMemo, useEffect } from 'react';
import { formatDateString, parseDateFromSlashFormat } from '../../../helpers/Util';
import DateRangePicker from '../../DateRangePicker/DateRangePicker';

interface OtsStartDateFilterProps {
    startDate: string;
    endDate: string;
    onOtsDateChange: (start: string, end: string) => void;
    onOTSStartDateError: (error: boolean) => void;
    error?: boolean;
}

const OtsStartDateFilter: React.FC<OtsStartDateFilterProps> = ({
    startDate,
    endDate,
    onOtsDateChange,
    onOTSStartDateError,
    error = false
}) => {

    const today = useMemo(() => {
    const date = new Date();
    date.setHours(0, 0, 0, 0); 
    return date;
    }, []);
    const [isOTSStartDateError, setOTSStartDateError] = useState(false);

    const parseDate = (dateStr: string): Date | null => {
        if (!dateStr) return null;
        return parseDateFromSlashFormat(dateStr);
    };

    useEffect(() => {
        setOTSStartDateError(error);
    }, [error]);
    
    const handleDateChange = (range: { startDate: Date | null; endDate: Date | null }) => {
        console.log('handleDateChange called with range:', range);
  const startStr = range.startDate ? formatDateString(range.startDate, 'mm/dd/yyyy') : '';
  const endStr = range.endDate ? formatDateString(range.endDate, 'mm/dd/yyyy') : '';
  
  onOtsDateChange(startStr, endStr); 

  const isValid = validateDates(startStr, endStr);
  setOTSStartDateError(!isValid);
  onOTSStartDateError(!isValid);
};




    const validateDates = (from: string, to: string): boolean => {
        const fromDate = from ? parseDateFromSlashFormat(from) : null;
        const toDate = to ? parseDateFromSlashFormat(to) : null;
        const todayDate = new Date();
        todayDate.setHours(23, 59, 59, 999);

      
        if ((from && !to) || (to && !from)) {
            return false;
        }

   
        if (from && !from.match(/^\d{2}\/\d{2}\/\d{4}$/)) {
            return false;
        }
        if (to && !to.match(/^\d{2}\/\d{2}\/\d{4}$/)) {
            return false;
        }

     
        if (fromDate && toDate && fromDate > toDate) {
            return false;
        }

    
        if ((fromDate && fromDate > todayDate) || (toDate && toDate > todayDate)) {
            return false;
        }

        return true;
    };

  
    const initialStartDate = useMemo(() => parseDate(startDate), [startDate]);
    const initialEndDate = useMemo(() => parseDate(endDate), [endDate]);


    return (
        <div className="form-input">
            <DateRangePicker
                beginningLabelText='OTS start from'
                endingLabelText='to'
                startDate={initialStartDate}
                endDate={initialEndDate}
                onDateChange={handleDateChange}
                maxDate={today}
                className="auro-closed-events-date-picker"
            />
            {isOTSStartDateError && (
                <div className="dateTimeError">Enter valid OTS start from and to date</div>
            )}
        </div>
    );
};

export default OtsStartDateFilter;
